import React, { useEffect, useRef } from "react";

export default function GlowCursor() {
  const glowRef = useRef(null);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return undefined;

    let frame;
    const moveCursor = (event) => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const position = `translate3d(${event.clientX}px, ${event.clientY}px, 0)`;
        if (glowRef.current) glowRef.current.style.transform = position;
      });
    };

    const tiltCard = (event) => {
      const card = event.target.closest(".tilt-card");
      if (!card) return;
      const bounds = card.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width - 0.5;
      const y = (event.clientY - bounds.top) / bounds.height - 0.5;
      card.style.setProperty("--tilt-x", `${(-y * 8).toFixed(2)}deg`);
      card.style.setProperty("--tilt-y", `${(x * 10).toFixed(2)}deg`);
      card.style.setProperty("--shine-x", `${((x + 0.5) * 100).toFixed(1)}%`);
      card.style.setProperty("--shine-y", `${((y + 0.5) * 100).toFixed(1)}%`);
    };

    const resetCard = (event) => {
      const card = event.target.closest(".tilt-card");
      if (!card || event.relatedTarget?.closest?.(".tilt-card") === card) return;
      card.style.removeProperty("--tilt-x");
      card.style.removeProperty("--tilt-y");
    };

    window.addEventListener("pointermove", moveCursor, { passive: true });
    document.addEventListener("pointermove", tiltCard, { passive: true });
    document.addEventListener("pointerout", resetCard, { passive: true });
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("pointermove", moveCursor);
      document.removeEventListener("pointermove", tiltCard);
      document.removeEventListener("pointerout", resetCard);
    };
  }, []);

  return (
    <div className="cursor-effects" aria-hidden="true">
      <span ref={glowRef} className="cursor-glow" />
    </div>
  );
}
